// import { serverOnly$ } from "vite-env-only/macros";

import enWidget from "../locales/widget/en.json" with { type: "json" };
import deWidget from "../locales/widget/de.json" with { type: "json" };
// import esWidget from "../locales/landing/es.json";
// import frWidget from "../locales/landing/fr.json";
// import ptWidget from "../locales/landing/pt.json";

// import enWebhook from "../locales/webhooks/en.json";
// import deWebhook from "../locales/webhooks/de.json";
// import esWebhook from "../locales/webhooks/es.json";
// import frWebhook from "../locales/webhooks/fr.json";
// import ptWebhook from "../locales/webhooks/pt.json";

// import esTranslation from "../locales/es";
import enTranslation from "../locales/en.json" with { type: "json" };
import deTranslation from "../locales/de.json" with { type: "json" };
// import frTranslation from "../locales/fr";
// import ptTranslation from "../locales/pt";

import enEmail from "../locales/email/en.json" with { type: "json" };
import deEmail from "../locales/email/de.json" with { type: "json" };
// import esEmail from "../locales/email/es.json";
// import frEmail from "../locales/email/fr.json";
// import ptEmail from "../locales/email/pt.json";


// This is the list of languages your application supports, the last one is your
// fallback language
export const supportedLngs = [
  "en",
  "de",
  // "es",
  // "fr",
  // "pt"
];

// This is the language you want to use in case
// the user language is not in the supportedLngs
export const fallbackLng = "en";

// The default namespace of i18next is "translation", but you can customize it
export const defaultNS = "translation";

export const resources = {
  en: {
    translation: {
      ...enTranslation,
      ...enWidget,
      ...enEmail
    }
  },
  // es: {
  //   translation: {
  //     ...esTranslation,
  //     ...esWidget,
  //     ...esEmail
  //   } },
  de: {
    translation: {
      ...deTranslation,
      ...deWidget,
      ...deEmail
      // ...deWebhook
    }
  },
  // fr: { translation: { ...frTranslation, ...frLanding, ...frWebhook } },
  // pt: { translation: { ...ptTranslation, ...ptLanding, ...ptWebhook } },
};